class ChangePassword {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }
  set(email, oldPassword, newPassword) {
    return this.apiClient.post('v1/users/change-password', {
      email,
      'new-password': newPassword,
      'old-password': oldPassword
    }).then(response => response.data);
  }
}

export { ChangePassword };
//# sourceMappingURL=ChangePassword.js.map
